import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Copy-1--Streamline-Flex"
    >
        <desc>{'Copy 1 Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="copy-1">
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.33766 0.718911c-0.06927 0.007461 -0.13832 0.015112 -0.20714 0.022869 -0.72948 0.082224 -1.315686 0.66837 -1.394736 1.3982 -0.007312 0.06751 -0.014512 0.13524 -0.021527 0.20318m0.002966 5.81211c0.007015 0.06794 0.014214 0.13567 0.021527 0.20318 0.060532 0.55886 0.41845 1.03347 0.91035 1.26208M0.509575 4.62714c-0.012767 0.41508 -0.012767 0.82616 0 1.24124M8.16947 0.716872c0.06927 0.007461 0.13832 0.015112 0.20715 0.022869 0.55325 0.062361 1.02409 0.414579 1.25378 0.899499M4.63168 0.509575c0.41508 -0.012767 0.82616 -0.012767 1.24124 0"
                strokeWidth={1}
            />
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.3404 11.2337c-0.0604 0.5346 -0.3001 1.033 -0.68 1.414 -0.38 0.3809 -0.8778 0.6219 -1.4123 0.6836 -0.8132 0.0912 -1.6469 0.1687 -2.4981 0.1687s-1.68568 -0.0775 -2.49812 -0.1687c-0.53448 -0.0617 -1.03229 -0.3027 -1.41226 -0.6836 -0.37996 -0.381 -0.61967 -0.8794 -0.68002 -1.414C4.07296 10.4258 4 9.59588 4 8.75c0 -0.84588 0.07296 -1.6758 0.1596 -2.48444 0.06035 -0.53464 0.30006 -1.03306 0.68002 -1.41399 0.37997 -0.38093 0.87778 -0.6219 1.41226 -0.68361C7.06508 4.07828 7.8988 4 8.75 4c0.8512 0 1.6857 0.07752 2.4981 0.16872 0.5345 0.06171 1.0323 0.30268 1.4123 0.68361 0.3799 0.38093 0.6196 0.87935 0.68 1.41399 0.0866 0.80712 0.1596 1.63704 0.1596 2.48368 0 0.84664 -0.073 1.6758 -0.1596 2.4837Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
